'use strict';

import type { UserApiToken } from '../../Entities/User/UserApiToken';
import { EntityCollection } from '../EntityCollection';

export class UserApiTokenCollection extends EntityCollection<UserApiToken> { }

